import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';
  import Modal from '@/components/common/Modal.vue';
  import { Address } from '@/types/widgets/tenantsWidget/tenantsWidget';
  import { Multiselect } from 'vue-multiselect';
  import { useToasted } from '@/helpers';
  import { apiGetAddresses } from '@/api/tenants';
  import { demoTenantAddress } from '@/constant/tenants';

  
  import { defineComponent } from 'vue';

  const __default__ = defineComponent({
    name: 'CreateTenantsWidgetModal',
  });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["createTenantsWidget", "closeModal"],
  setup(__props, { emit: emits }: { emit: ({
    (event: 'createTenantsWidget', value: { name: string; address: Address }): void;
    (event: 'closeModal', value: void): void;
  }), expose: any, slots: any, attrs: any }) {

  

  const toasted = useToasted();

  const showModal = ref(false);
  const isSaving = ref(false);
  const widgetName = ref('Tenants');
  const organisationAddresses = ref<Address[]>([demoTenantAddress]);
  const selectedAddress = ref<Address | null>(null);
  const loading = ref(false);

  const disableOkButton = computed(() => {
    return widgetName.value.length < 3 || !selectedAddress.value;
  });

  onMounted(() => {
    showModal.value = true;
  });

  async function getAddresses() {
    try {
      loading.value = true;
      const response = await apiGetAddresses();

      organisationAddresses.value = response.map((building) => ({
        id: building.externalId,
        name: building.streetAddress,
      }));

      organisationAddresses.value.unshift(demoTenantAddress);
    } catch (error) {
      toasted.global.general_error({
        message: "Error getting your organisation's addresses",
      });
    }

    loading.value = false;
  }

  async function createTenantsWidget() {
    if (!selectedAddress.value) return;

    isSaving.value = true;

    const data = {
      name: widgetName.value,
      address: selectedAddress.value,
    };

    emits('createTenantsWidget', data);
    isSaving.value = false;
    closeModal();
  }

  function closeModal() {
    showModal.value = false;
    emits('closeModal');
  }

  getAddresses();

return { __sfc: true,emits, toasted, showModal, isSaving, widgetName, organisationAddresses, selectedAddress, loading, disableOkButton, getAddresses, createTenantsWidget, closeModal, Modal, Multiselect }
}

})